import { AutoPayScheduleScreen } from './AutoPaySchedule'
import { AutoPayFundingSourceScreen } from './AutoPayFundingSource'
import { AutoPayReviewScreen } from './AutoPayReview'
import { AutoPaySuccessScreen } from './AutoPaySuccess'
import { MakePaymentScreen } from './MakePayment'
import { AutoPayScheduleReviewScreen } from './AutoPayScheduleReview'
import { AutoPayAgreementScreen } from './AutoPayAgreement'
import { OnetimePayFundingSourceScreen } from './OnetimePayFundingSource'
import { OnetimePayScheduleScreen } from './OnetimePaySchedule'
import { OnetimePayReviewScreen } from './OnetimePayReview'
import { OnetimePaySuccessScreen } from './OnetimePaySuccess'

export const CardPaymentsScreens = {
  MakePayment: MakePaymentScreen,
  AutoPaySchdule: AutoPayScheduleScreen,
  AutoPayScheduleReview: AutoPayScheduleReviewScreen,
  AutoPayFundingSource: AutoPayFundingSourceScreen,
  AutoPayReview: AutoPayReviewScreen,
  AutoPayAgreement: AutoPayAgreementScreen,
  AutoPaySuccess: AutoPaySuccessScreen,
  OnetimePaySchedule: OnetimePayScheduleScreen,
  OnetimePayFundingSource: OnetimePayFundingSourceScreen,
  OnetimePayReview: OnetimePayReviewScreen,
  OnetimePaySuccess: OnetimePaySuccessScreen,
}
